import {
  GuidedIntakePageTypes,
  type GuidedIntakePageTypeEnum,
} from '../value-objects/enums'

export const getGuidedIntakePageType = (
  location: Pick<Location, 'hash'> = window.location
): GuidedIntakePageTypeEnum =>
  location.hash.startsWith('#/')
    ? GuidedIntakePageTypes.CLASSIC
    : GuidedIntakePageTypes.NEXT_GEN
